import { useAuth } from '@tom-ui/utils'
import { Button, Stack, Typography } from '@mui/material'
import { useOperationsStore } from '@operations/AppProvider'
import { equipmentService } from '@operations/services'
import { useTranslate } from '@tolgee/react'
import { observer } from 'mobx-react-lite'
import { FormProvider, useForm } from 'react-hook-form'
import { SelectEquipment } from '../components/SelectEquipment/SelectEquipment'
import { SelectGang } from '../components/SelectEquipment/SelectGang'
import { SelectOperationType } from '../components/SelectEquipment/SelectOperationType'
import { SelectVesselVisit } from '../components/SelectEquipment/SelectVesselVisit'
import { EquipmentOperatorLandingFormData } from '../stores/equipment-operator-landing.ui-store'

export const EquipmentOperatorLandingContainer = observer(() => {
  const { t } = useTranslate()

  const { equipmentOperatorLandingUIStore, tenantConfigStore } = useOperationsStore()
  const { user } = useAuth()

  const onContinueClick = async (data: EquipmentOperatorLandingFormData) => {
    if (!data.equipmentId) return

    await equipmentService.updateEquipmentResponsibleUser(data.equipmentId, user?.sub ?? '')

    equipmentOperatorLandingUIStore.selectEquipment(data.equipmentId)
    equipmentOperatorLandingUIStore.selectVesselVisit(data.vesselVisit)
    equipmentOperatorLandingUIStore.selectOperationType(data.operationType ?? null)
    equipmentOperatorLandingUIStore.selectGang(data.gang)
  }

  const form = useForm<EquipmentOperatorLandingFormData>()

  return (
    <Stack justifyContent='center' alignItems='center' height={'70vh'}>
      {equipmentOperatorLandingUIStore.equipmentOptions.length ? (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onContinueClick)} noValidate>
            <Stack gap={theme => theme.customSpacing.l} width={'270px'} alignItems='center'>
              <Typography variant='h1'>{t('selectEquipment', 'Select equipment')}</Typography>

              <SelectEquipment uiStore={equipmentOperatorLandingUIStore} />

              {equipmentOperatorLandingUIStore.displayVesselVisitSelector && (
                <SelectVesselVisit uiStore={equipmentOperatorLandingUIStore} />
              )}
              {equipmentOperatorLandingUIStore.displayOperationsTypeSelector && (
                <SelectOperationType uiStore={equipmentOperatorLandingUIStore} />
              )}

              {!tenantConfigStore.skipGangSelection && (
                <SelectGang uiStore={equipmentOperatorLandingUIStore} />
              )}

              <Button
                type='submit'
                variant='contained'
                color='primary'
                fullWidth
                disabled={!form.formState.isValid}
                data-cy='operator-landing-continue-btn'
              >
                {t('continue', 'Continue')}
              </Button>
            </Stack>
          </form>
        </FormProvider>
      ) : (
        <Typography variant='subtitle1' color='secondary'>
          {t('noEquipmentFound', 'No equipment found')}
        </Typography>
      )}
    </Stack>
  )
})
